import { map, prop, values as rValues, pipe, find, propEq, path, pathOr } from 'ramda'
import { recipientColors } from './colors'

const getUniqueColor = (recipients = {}, documents = []) => {
  const tenancyAgreementId = pipe(
    find(propEq('document_type', 'tenancy_agreement')),
    prop('id')
  )(documents)

  const getUserColor = x =>
    pipe(
      pathOr([], ['contract_documents']),
      find(propEq('listing_contract_package_file_id', Number(tenancyAgreementId))),
      path(['metadata', 'color'])
    )(x)
  const colorsUsed = map(getUserColor)(rValues(recipients))

  const unUnsed = recipientColors.filter(el => colorsUsed.indexOf(el) < 0)
  return unUnsed[0]
}

export default getUniqueColor
